/**
 * @generated SignedSource<<ec9e5db62b0ac71dffc3172fdbf2d4b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PostAccessRecipientStatusEnum = "ACTIVE" | "EXPIRED" | "REVOKED";
export type CreatePostAccessRecipientInput = {
  authorId?: string | null | undefined;
  created?: string | null | undefined;
  domain: string;
  email: string;
  expiresAt?: string | null | undefined;
  modified?: string | null | undefined;
  postId: string;
  status: PostAccessRecipientStatusEnum;
  type: string;
};
export type Utils_CreatePostAccessRecipient_Mutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreatePostAccessRecipientInput;
};
export type Utils_CreatePostAccessRecipient_Mutation$data = {
  readonly createPostAccessRecipient: {
    readonly postAccessRecipient: {
      readonly created: string | null | undefined;
      readonly domain: string;
      readonly email: string;
      readonly expiresAt: string | null | undefined;
      readonly id: string;
      readonly modified: string | null | undefined;
      readonly status: PostAccessRecipientStatusEnum;
    } | null | undefined;
  } | null | undefined;
};
export type Utils_CreatePostAccessRecipient_Mutation = {
  response: Utils_CreatePostAccessRecipient_Mutation$data;
  variables: Utils_CreatePostAccessRecipient_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PostAccessRecipient",
  "kind": "LinkedField",
  "name": "postAccessRecipient",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domain",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expiresAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modified",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "Utils_CreatePostAccessRecipient_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreatePostAccessRecipientPayload",
        "kind": "LinkedField",
        "name": "createPostAccessRecipient",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "Utils_CreatePostAccessRecipient_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "CreatePostAccessRecipientPayload",
        "kind": "LinkedField",
        "name": "createPostAccessRecipient",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "postAccessRecipient",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "PostAccessRecipient"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c024b6f3348728953a7004c1862c9df4",
    "id": null,
    "metadata": {},
    "name": "Utils_CreatePostAccessRecipient_Mutation",
    "operationKind": "mutation",
    "text": "mutation Utils_CreatePostAccessRecipient_Mutation(\n  $input: CreatePostAccessRecipientInput!\n) {\n  createPostAccessRecipient(input: $input) {\n    postAccessRecipient {\n      id\n      email\n      domain\n      status\n      expiresAt\n      created\n      modified\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "acaedb3ae537721d2f21c77d0f9bf94a";

export default node;
